import { createContext } from "react";
import i18next from "i18next";

import { LIST_LANGUAGE_ENUM } from "../constants";

import { LanguageContext } from "../types/language";

import { LOCAL_STORAGE_KEY_CURRENT_LANGUAGE } from "../constants";


const languageFromLocalStorage = localStorage.getItem(LOCAL_STORAGE_KEY_CURRENT_LANGUAGE);

export const defaultLanguageContext: LanguageContext = {
    language: languageFromLocalStorage !== null
        ? languageFromLocalStorage
        : typeof process.env.REACT_APP_DEFAULT_LANGUAGE === "undefined"
            ? LIST_LANGUAGE_ENUM.EN
            : Object.values(LIST_LANGUAGE_ENUM).includes(process.env.REACT_APP_DEFAULT_LANGUAGE)
                ? process.env.REACT_APP_DEFAULT_LANGUAGE
                : i18next.language,
    setLanguage: () => {}
};

export const languageContext = createContext<LanguageContext>(defaultLanguageContext);
